__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-push-messaging/v3_5_16/";